// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {is_offer_started, is_offer_done} from '../../utils/misc.js';
import {Platform_list} from './platform_list.js';
import * as cns from './cover.module.less';

function Overlay({data, overlay_class, action_class}){
    const is_started = is_offer_started(data);
    const is_done = is_offer_done(data);
    let open_txt = 'Start offer';
    let icon = 'play';
    if (is_started)
    {
        open_txt = 'View';
        icon = 'play';
    }
    else if (is_done)
    {
        open_txt = 'View';
        icon = 'play';
    }
    return <div className={cn(cns.overlay, overlay_class)}>
      <div className={cns.overlay_wrap}>
        <div className={cn(cns.ico_wrap, action_class)}>
          <Icon ico={icon}/>
        </div>
        <Text.m className={cns.overlay_caption} span>{open_txt}</Text.m>
      </div>
    </div>;
}

export function Cover({
    data,
    className,
    overlay_class,
    img_class,
    action_class,
    platforms_class,
    has_overlay,
    lazy,
})
{
    return <div className={cn(cns.root, className)}>
      <img className={cn(cns.img, img_class)} src={data.icon}
        loading={lazy ? 'lazy': 'eager'} alt={data.description}/>
      <Platform_list className={cn(cns.platforms, platforms_class)}
        offer={data} compact/>
      {has_overlay&&<Overlay data={data} overlay_class={overlay_class}
        action_class={action_class}/>}
    </div>;
}
